import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const userPreferenceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserPreference: builder.query({
      query: (patientId: number) => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/PatientPreference/${patientId}/user-preference`,
          method: "GET",
          headers,
        };
      },
      providesTags: [{ type: "UserPreference" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserPreferenceQuery } = userPreferenceApi;
export default userPreferenceApi;
